<template>
  <div class="CreateCompte p-0 m-0">
    <Navbar title="Yajobici" />
    <div class="container-fluid p-0">
      <div class="section_1 mt-5 mb-5" style="margin-top: 155px !important"> </div>

      <div class="text-center">
        <h4>Inscrivez-vous gratuitement en quelques clics !</h4>
      </div>
    <div class="row py-5 px-5 g-0"> 
      <div class="col-lg-6 mb-2 p-2">
        <router-link to="/creation-de-compte-prestataire" class="card card_P p-5">
          <h4 style="color: #2B3940 !important;">Valorisez votre savoir-faire et trouvez des clients</h4>
          <p>Inscrivez-vous, présentez vos services et recevez des demandes adaptées à votre domaine d’activité.</p>
          <span>Je suis un prestataire <i class="fas fa-arrow-right ms-2"></i></span>
        </router-link>
      </div>
 
      <div class="col-lg-6 mb-2 p-2">
        <router-link to="/creation-de-compte-recruteur" class="card card_R p-5">
          <h4 style="color: #2B3940 !important;">Trouvez le prestataire qu’il vous faut</h4>
          <p>Trouvez rapidement des prestataires fiables, disponibles et proches de vous pour tous vos besoins.</p><br>
          <span class="mb-1">Je veux recruter <i class="fas fa-arrow-right ms-2"></i></span>
        </router-link>
      </div>
   </div>

 </div>

  </div>
</template>

<script>
import Navbar from "../../components/Navbar.vue";
export default {
  name: "CreateCompte",
  components: {
    Navbar,
  },
}
</script>

<style scoped>

  .card{
    height: auto !important;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
    transition: all 0.35s ease;
    color: #2B3940 !important;
  }

  .card_P{
    border: 2px solid #61C7F2 !important;
  }

  .card_R{
    border: 2px solid #F7A51B !important;
  }

  .card_P:hover{
    background-color: #61C7F2;
    transform: translateX(8px);
    box-shadow: 0 20px 40px rgba(97, 199, 242, 0.35);
    color: #ffffff !important;
  }
  .card_R:hover{
    background-color: #F7A51B;
    transform: translateX(8px);
    box-shadow: 0 20px 40px rgba(97, 199, 242, 0.35);
    color: #ffffff !important;
  }
  .CreateCompte{
    position: absolute;
  inset: 0;
  background-image:
    
    url(../../assets/img/bgwel3.jpg);
  background-size: cover;
  background-position: center;
  }
</style>